import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IBulkResponseRecord,
  IGetManyResponse,
  IGetOneResponse,
} from '../../shared/model/interface/crud-response-interface.model';
import { IChildrenOfSelectedLogbooks, IGrantStateRecordData } from './grant-state-to-children.model';
import { IIssuerAndReason } from '../../shared/component/before-action-preparer/before-action-preparer.model';

@Injectable({
  providedIn: 'root',
})
export class GrantStateToChildrenService {
  private readonly URLS = {
    CHILDREN_OF_SELECTED_LOGBOOKS: `${this.baseUrl}/logbooks/children-all-tree`,
    GRANT_STATE: `${this.baseUrl}/logbooks/grant-current-state`,
  };

  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  public getChildrenOfSelectedLogbooksData(
    logbookId: number,
    issuerAndReason: IIssuerAndReason | null,
  ): Observable<IGetManyResponse<IChildrenOfSelectedLogbooks>> {
    return this.http.post<IGetManyResponse<IChildrenOfSelectedLogbooks>>(
      `${this.URLS.CHILDREN_OF_SELECTED_LOGBOOKS}/${logbookId}`,
      {
        issuer: issuerAndReason?.issuer,
        payload: {},
      },
    );
  }

  public grantStateToChildrenOfSelectedLogbook(
    logbookId: number,
    childLogbookIds: number[],
    issuerAndReason: IIssuerAndReason | null,
  ): Observable<IBulkResponseRecord<IGetOneResponse<IGrantStateRecordData>>> {
    return this.http.post<IBulkResponseRecord<IGetOneResponse<IGrantStateRecordData>>>(
      `${this.URLS.GRANT_STATE}/${logbookId}`,
      {
        issuer: issuerAndReason?.issuer,
        payload: {
          childLogbookIds,
          reason: issuerAndReason?.reason,
        },
      },
    );
  }
}
